import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicWidgetProperties } from 'book-widgets/interfaces';
import { createNlsMiddleware } from 'lcc-state';
import { TopicDetails } from '@holmescorp/lcc-state/interfaces';
import { LearningActivity } from '@holmescorp/learning-activity';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const nls = createNlsMiddleware('activities');
const factory = create({ theme, nls }).properties<TopicWidgetProperties>();

export const Storyline = factory(({ properties, middleware: { theme, nls } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);
	const data = topicdata as TopicDetails;

	const { messages } = nls();
	const { attributes = { id: '' } } = data;

	const { portal_userid: uid, sessionid } = window.hcstatic;

	const storyline = messages[`storyline_${attributes.id}`];
	const title = messages[`storyline_title_${attributes.id}`];
	const index = messages[`storyline_index_file`] || 'index_lms.html';

	const storyline_path = messages['storyline_path'];
	const cdn_path = storyline_path ? storyline_path : `${window.hcstatic.portal_cdn}/files/storyline`;

	const endpoint = encodeURIComponent(`${window.hcstatic.portal_url}/@@lrs/xapi/`);
	const actor = encodeURIComponent(
		`{"objectType":"Agent","name":"${uid}","mbox":"mailto:${uid}@example.com|${sessionid}"}`
	);
	const auth = encodeURIComponent(`Bearer ${window.hcstatic.xapi_token}`);
	const risepath = `${cdn_path}/${storyline}/${index}`;
	const queryparams = `?endpoint=${endpoint}&actor=${actor}&auth=${auth}`;
	const url = `${risepath}${queryparams}`;

	return v('div', { classes: [themeCss.storyline, ...additionalClasses] }, [
		storyline
			? w(LearningActivity, {
					activityname: `storyline-${storyline}`,
					url,
					title,
					checkSize: false
			  })
			: null
	]);
});
